// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lista-anunturi { display: flex; flex-direction: column; gap: 24px; }

.lista-goala {
  text-align: center; padding: 60px; color: #aaa;
  display: flex; flex-direction: column; align-items: center; gap: 12px;
}

.anunt-card-complet {
  display: flex; gap: 20px;
  background: #fff; border: 1.5px solid #eee;
  border-radius: 16px; padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.anunt-imagini {
  display: flex; flex-direction: column;
  gap: 8px; min-width: 140px;
}
.anunt-imagini img {
  width: 140px; height: 120px;
  object-fit: cover; border-radius: 10px;
}
.no-image {
  width: 140px; height: 120px; background: #f5f5f5;
  border-radius: 10px; display: flex; flex-direction: column;
  align-items: center; justify-content: center; gap: 8px;
  color: #aaa; font-size: 13px;
}

.anunt-detalii { flex: 1 1; display: flex; flex-direction: column; gap: 14px; }

.anunt-header { display: flex; justify-content: space-between; align-items: center; }

.badge { padding: 4px 12px; border-radius: 20px; font-size: 13px; font-weight: 600; }
.badge-gasit { background: #dcfce7; color: #16a34a; }
.badge-pierdut { background: #fee2e2; color: #dc2626; }

.anunt-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
.anunt-item { display: flex; flex-direction: column; gap: 2px; }
.label { font-size: 11px; text-transform: uppercase; color: #999; font-weight: 600; }

.anunt-descriere { display: flex; flex-direction: column; gap: 4px; }
.anunt-descriere p { margin: 0; color: #444; font-size: 14px; line-height: 1.5; }

.anunt-butoane { display: flex; gap: 10px; }

.btn-edit {
  display: flex; align-items: center; gap: 6px;
  padding: 8px 16px; background: #eff6ff;
  color: #2563eb; border: none; border-radius: 8px;
  cursor: pointer; font-weight: 600; font-size: 13px;
}
.btn-edit:hover { background: #dbeafe; }

.btn-sterge {
  display: flex; align-items: center; gap: 6px;
  padding: 8px 16px; background: #fee2e2;
  color: #dc2626; border: none; border-radius: 8px;
  cursor: pointer; font-weight: 600; font-size: 13px;
}
.btn-sterge:hover { background: #fecaca; }

/* Edit form */
.edit-form { display: flex; flex-direction: column; gap: 12px; }
.edit-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
.edit-grid select, .edit-grid input {
  padding: 8px 12px; border: 1.5px solid #ddd;
  border-radius: 8px; font-size: 14px; outline: none;
}
.edit-grid select:focus, .edit-grid input:focus { border-color: #f97316; }
.edit-form textarea {
  padding: 10px; border: 1.5px solid #ddd;
  border-radius: 8px; font-size: 14px; resize: vertical; outline: none;
}
.edit-butoane { display: flex; gap: 10px; }
.btn-salveaza {
  display: flex; align-items: center; gap: 6px;
  padding: 10px 20px; background: #f97316;
  color: white; border: none; border-radius: 8px;
  cursor: pointer; font-weight: 600;
}
.btn-anuleaza {
  display: flex; align-items: center; gap: 6px;
  padding: 10px 20px; background: #f3f4f6;
  color: #666; border: none; border-radius: 8px; cursor: pointer;
}

/* Donație */
.donatie-section {
  border-top: 1.5px dashed #f97316;
  padding-top: 14px; display: flex; flex-direction: column; gap: 12px;
}
.btn-donatie-toggle {
  display: flex; align-items: center; gap: 8px;
  background: none; border: 2px solid #f97316;
  color: #f97316; padding: 10px 18px;
  border-radius: 10px; cursor: pointer;
  font-weight: 600; font-size: 14px; width: fit-content;
}
.btn-donatie-toggle:hover { background: #fff7ed; }

.donatie-box { display: flex; flex-direction: column; gap: 14px; }
.donatie-info {
  background: #fff7ed; border-radius: 10px; padding: 14px;
}
.donatie-split { display: flex; gap: 20px; flex-wrap: wrap; }
.donatie-split div {
  display: flex; align-items: center; gap: 8px;
  font-size: 14px; color: #444;
}

.donatie-sume { display: flex; gap: 10px; flex-wrap: wrap; }
.btn-suma {
  padding: 10px 18px; background: white;
  border: 2px solid #f97316; color: #f97316;
  border-radius: 10px; cursor: pointer;
  font-weight: 700; font-size: 15px;
  transition: all 0.2s;
}
.btn-suma:hover { background: #f97316; color: white; }

@media (max-width: 600px) {
  .anunt-card-complet { flex-direction: column; }
  .anunt-imagini { flex-direction: row; flex-wrap: wrap; min-width: unset; }
  .anunt-imagini img { width: 100px; height: 80px; }
  .anunt-grid, .edit-grid { grid-template-columns: 1fr; }
  .donatie-split { flex-direction: column; }
}
.btn-succes {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: green;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  box-shadow: 0 2px 8px rgba(249,115,22,0.3);
}
.btn-succes:hover { opacity: 0.9; transform: translateY(-1px); }

.succes-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease;
}

.succes-modal {
  background: white;
  border-radius: 20px;
  padding: 32px;
  max-width: 460px;
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  animation: slideUp 0.25s ease;
}

.succes-modal-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.succes-modal-header h3 {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.succes-modal-header p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.succes-textarea {
  padding: 12px;
  border: 1.5px solid #ddd;
  border-radius: 10px;
  font-size: 14px;
  resize: vertical;
  outline: none;
  font-family: 'Baloo 2', cursive;
}
.succes-textarea:focus { border-color: #f97316; }

.succes-modal-butoane {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-confirma-succes {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  background: linear-gradient(135deg, #f97316, #fbbf24);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}
.btn-confirma-succes:hover { opacity: 0.9; }

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.btn-promoveaza {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #f4b400;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
}
.btn-promoveaza:hover { opacity: 0.9; }
.btn-promoveaza.deja-promovat {
  background: #fef3c7;
  color: #92400e;
  cursor: default;
}
/* ================= BASE (MOBILE FIRST) ================= */

.lista-anunturi {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px;
}

.anunt-card-complet {
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.06);
}

/* IMAGINI */
.anunt-imagini {
  display: flex;
  gap: 8px;
  overflow-x: auto;
}

.anunt-imagini img,
.no-image {
  width: 100px;
  height: 80px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 8px;
}

/* HEADER */
.anunt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* GRID INFO */
.anunt-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

/* DESCRIERE */
.anunt-descriere p {
  font-size: 13px;
  line-height: 1.4;
}

/* BUTOANE */
.anunt-butoane {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.anunt-butoane button {
  width: 100%;
  justify-content: center;
}

/* DONATIE */
.donatie-split {
  flex-direction: column;
  gap: 10px;
}

/* ================= TABLET (>= 600px) ================= */

@media (min-width: 600px) {

  .anunt-card-complet {
    flex-direction: row;
    padding: 18px;
  }

  .anunt-imagini {
    flex-direction: column;
    min-width: 120px;
  }

  .anunt-imagini img,
  .no-image {
    width: 120px;
    height: 100px;
  }

  .anunt-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .anunt-butoane {
    flex-direction: row;
  }

  .anunt-butoane button {
    width: auto;
  }
}

/* ================= DESKTOP (>= 1024px) ================= */

@media (min-width: 1024px) {

  .lista-anunturi {
    max-width: 1100px;
    margin: 0 auto;
  }

  .anunt-card-complet {
    gap: 24px;
    padding: 22px;
    border-radius: 18px;
  }

  .anunt-imagini img,
  .no-image {
    width: 140px;
    height: 110px;
  }

  .anunt-descriere p {
    font-size: 14px;
  }
}
.card-promovat {
  border: 2px solid #f4b400;
  box-shadow: 0 4px 20px rgba(244, 180, 0, 0.15);
}

.promovat-ribbon {
  background: linear-gradient(135deg, #f4b400, #f97316);
  color: white;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 8px 8px 0 0;
  height: 20px;
}

.btn-promoveaza {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #f4b400, #f97316);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
}
.btn-promoveaza:hover { opacity: 0.9; }
.btn-promoveaza.deja-promovat {
  background: #fef3c7;
  color: #92400e;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/ListaAnunturiMele.css"],"names":[],"mappings":"AAAA,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEpE;EACE,kBAAkB,EAAE,aAAa,EAAE,WAAW;EAC9C,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,SAAS;AACvE;;AAEA;EACE,aAAa,EAAE,SAAS;EACxB,gBAAgB,EAAE,wBAAwB;EAC1C,mBAAmB,EAAE,aAAa;EAClC,uCAAuC;AACzC;;AAEA;EACE,aAAa,EAAE,sBAAsB;EACrC,QAAQ,EAAE,gBAAgB;AAC5B;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,iBAAiB,EAAE,mBAAmB;AACxC;AACA;EACE,YAAY,EAAE,aAAa,EAAE,mBAAmB;EAChD,mBAAmB,EAAE,aAAa,EAAE,sBAAsB;EAC1D,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ;EACtD,WAAW,EAAE,eAAe;AAC9B;;AAEA,iBAAiB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE5E,gBAAgB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;;AAEpF,SAAS,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACpF,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;;AAEtD,cAAc,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;AAC/E,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/D,SAAS,eAAe,EAAE,yBAAyB,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAEpF,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACpE,qBAAqB,SAAS,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEhF,iBAAiB,aAAa,EAAE,SAAS,EAAE;;AAE3C;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB,EAAE,mBAAmB;EACtC,cAAc,EAAE,YAAY,EAAE,kBAAkB;EAChD,eAAe,EAAE,gBAAgB,EAAE,eAAe;AACpD;AACA,kBAAkB,mBAAmB,EAAE;;AAEvC;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,iBAAiB,EAAE,mBAAmB;EACtC,cAAc,EAAE,YAAY,EAAE,kBAAkB;EAChD,eAAe,EAAE,gBAAgB,EAAE,eAAe;AACpD;AACA,oBAAoB,mBAAmB,EAAE;;AAEzC,cAAc;AACd,aAAa,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC/D,aAAa,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;AAC9E;EACE,iBAAiB,EAAE,wBAAwB;EAC3C,kBAAkB,EAAE,eAAe,EAAE,aAAa;AACpD;AACA,kDAAkD,qBAAqB,EAAE;AACzE;EACE,aAAa,EAAE,wBAAwB;EACvC,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,aAAa;AACtE;AACA,gBAAgB,aAAa,EAAE,SAAS,EAAE;AAC1C;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB,EAAE,mBAAmB;EACvC,YAAY,EAAE,YAAY,EAAE,kBAAkB;EAC9C,eAAe,EAAE,gBAAgB;AACnC;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB,EAAE,mBAAmB;EACvC,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe;AAChE;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS;AACrE;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,gBAAgB,EAAE,yBAAyB;EAC3C,cAAc,EAAE,kBAAkB;EAClC,mBAAmB,EAAE,eAAe;EACpC,gBAAgB,EAAE,eAAe,EAAE,kBAAkB;AACvD;AACA,4BAA4B,mBAAmB,EAAE;;AAEjD,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACjE;EACE,mBAAmB,EAAE,mBAAmB,EAAE,aAAa;AACzD;AACA,iBAAiB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC5D;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,eAAe,EAAE,WAAW;AAC9B;;AAEA,gBAAgB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC3D;EACE,kBAAkB,EAAE,iBAAiB;EACrC,yBAAyB,EAAE,cAAc;EACzC,mBAAmB,EAAE,eAAe;EACpC,gBAAgB,EAAE,eAAe;EACjC,oBAAoB;AACtB;AACA,kBAAkB,mBAAmB,EAAE,YAAY,EAAE;;AAErD;EACE,sBAAsB,sBAAsB,EAAE;EAC9C,iBAAiB,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;EACzE,qBAAqB,YAAY,EAAE,YAAY,EAAE;EACjD,0BAA0B,0BAA0B,EAAE;EACtD,iBAAiB,sBAAsB,EAAE;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;AACA,oBAAoB,YAAY,EAAE,2BAA2B,EAAE;;AAE/D;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,+BAA+B;AACjC;AACA,yBAAyB,qBAAqB,EAAE;;AAEhD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,6BAA6B,YAAY,EAAE;;AAE3C,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,wBAAwB,YAAY,EAAE;AACtC;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA,cAAc;AACd;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA,0DAA0D;;AAE1D;;EAEE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,4DAA4D;;AAE5D;;EAEE;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,wBAAwB,YAAY,EAAE;AACtC;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".lista-anunturi { display: flex; flex-direction: column; gap: 24px; }\n\n.lista-goala {\n  text-align: center; padding: 60px; color: #aaa;\n  display: flex; flex-direction: column; align-items: center; gap: 12px;\n}\n\n.anunt-card-complet {\n  display: flex; gap: 20px;\n  background: #fff; border: 1.5px solid #eee;\n  border-radius: 16px; padding: 20px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.06);\n}\n\n.anunt-imagini {\n  display: flex; flex-direction: column;\n  gap: 8px; min-width: 140px;\n}\n.anunt-imagini img {\n  width: 140px; height: 120px;\n  object-fit: cover; border-radius: 10px;\n}\n.no-image {\n  width: 140px; height: 120px; background: #f5f5f5;\n  border-radius: 10px; display: flex; flex-direction: column;\n  align-items: center; justify-content: center; gap: 8px;\n  color: #aaa; font-size: 13px;\n}\n\n.anunt-detalii { flex: 1; display: flex; flex-direction: column; gap: 14px; }\n\n.anunt-header { display: flex; justify-content: space-between; align-items: center; }\n\n.badge { padding: 4px 12px; border-radius: 20px; font-size: 13px; font-weight: 600; }\n.badge-gasit { background: #dcfce7; color: #16a34a; }\n.badge-pierdut { background: #fee2e2; color: #dc2626; }\n\n.anunt-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }\n.anunt-item { display: flex; flex-direction: column; gap: 2px; }\n.label { font-size: 11px; text-transform: uppercase; color: #999; font-weight: 600; }\n\n.anunt-descriere { display: flex; flex-direction: column; gap: 4px; }\n.anunt-descriere p { margin: 0; color: #444; font-size: 14px; line-height: 1.5; }\n\n.anunt-butoane { display: flex; gap: 10px; }\n\n.btn-edit {\n  display: flex; align-items: center; gap: 6px;\n  padding: 8px 16px; background: #eff6ff;\n  color: #2563eb; border: none; border-radius: 8px;\n  cursor: pointer; font-weight: 600; font-size: 13px;\n}\n.btn-edit:hover { background: #dbeafe; }\n\n.btn-sterge {\n  display: flex; align-items: center; gap: 6px;\n  padding: 8px 16px; background: #fee2e2;\n  color: #dc2626; border: none; border-radius: 8px;\n  cursor: pointer; font-weight: 600; font-size: 13px;\n}\n.btn-sterge:hover { background: #fecaca; }\n\n/* Edit form */\n.edit-form { display: flex; flex-direction: column; gap: 12px; }\n.edit-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }\n.edit-grid select, .edit-grid input {\n  padding: 8px 12px; border: 1.5px solid #ddd;\n  border-radius: 8px; font-size: 14px; outline: none;\n}\n.edit-grid select:focus, .edit-grid input:focus { border-color: #f97316; }\n.edit-form textarea {\n  padding: 10px; border: 1.5px solid #ddd;\n  border-radius: 8px; font-size: 14px; resize: vertical; outline: none;\n}\n.edit-butoane { display: flex; gap: 10px; }\n.btn-salveaza {\n  display: flex; align-items: center; gap: 6px;\n  padding: 10px 20px; background: #f97316;\n  color: white; border: none; border-radius: 8px;\n  cursor: pointer; font-weight: 600;\n}\n.btn-anuleaza {\n  display: flex; align-items: center; gap: 6px;\n  padding: 10px 20px; background: #f3f4f6;\n  color: #666; border: none; border-radius: 8px; cursor: pointer;\n}\n\n/* Donație */\n.donatie-section {\n  border-top: 1.5px dashed #f97316;\n  padding-top: 14px; display: flex; flex-direction: column; gap: 12px;\n}\n.btn-donatie-toggle {\n  display: flex; align-items: center; gap: 8px;\n  background: none; border: 2px solid #f97316;\n  color: #f97316; padding: 10px 18px;\n  border-radius: 10px; cursor: pointer;\n  font-weight: 600; font-size: 14px; width: fit-content;\n}\n.btn-donatie-toggle:hover { background: #fff7ed; }\n\n.donatie-box { display: flex; flex-direction: column; gap: 14px; }\n.donatie-info {\n  background: #fff7ed; border-radius: 10px; padding: 14px;\n}\n.donatie-split { display: flex; gap: 20px; flex-wrap: wrap; }\n.donatie-split div {\n  display: flex; align-items: center; gap: 8px;\n  font-size: 14px; color: #444;\n}\n\n.donatie-sume { display: flex; gap: 10px; flex-wrap: wrap; }\n.btn-suma {\n  padding: 10px 18px; background: white;\n  border: 2px solid #f97316; color: #f97316;\n  border-radius: 10px; cursor: pointer;\n  font-weight: 700; font-size: 15px;\n  transition: all 0.2s;\n}\n.btn-suma:hover { background: #f97316; color: white; }\n\n@media (max-width: 600px) {\n  .anunt-card-complet { flex-direction: column; }\n  .anunt-imagini { flex-direction: row; flex-wrap: wrap; min-width: unset; }\n  .anunt-imagini img { width: 100px; height: 80px; }\n  .anunt-grid, .edit-grid { grid-template-columns: 1fr; }\n  .donatie-split { flex-direction: column; }\n}\n.btn-succes {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: green;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  box-shadow: 0 2px 8px rgba(249,115,22,0.3);\n}\n.btn-succes:hover { opacity: 0.9; transform: translateY(-1px); }\n\n.succes-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.2s ease;\n}\n\n.succes-modal {\n  background: white;\n  border-radius: 20px;\n  padding: 32px;\n  max-width: 460px;\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.2);\n  animation: slideUp 0.25s ease;\n}\n\n.succes-modal-header {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.succes-modal-header h3 {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.succes-modal-header p {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n}\n\n.succes-textarea {\n  padding: 12px;\n  border: 1.5px solid #ddd;\n  border-radius: 10px;\n  font-size: 14px;\n  resize: vertical;\n  outline: none;\n  font-family: 'Baloo 2', cursive;\n}\n.succes-textarea:focus { border-color: #f97316; }\n\n.succes-modal-butoane {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.btn-confirma-succes {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px;\n  background: linear-gradient(135deg, #f97316, #fbbf24);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.btn-confirma-succes:hover { opacity: 0.9; }\n\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n@keyframes slideUp {\n  from { transform: translateY(30px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n.btn-promoveaza {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: #f4b400;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n}\n.btn-promoveaza:hover { opacity: 0.9; }\n.btn-promoveaza.deja-promovat {\n  background: #fef3c7;\n  color: #92400e;\n  cursor: default;\n}\n/* ================= BASE (MOBILE FIRST) ================= */\n\n.lista-anunturi {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 12px;\n}\n\n.anunt-card-complet {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  background: #fff;\n  border: 1px solid #eee;\n  border-radius: 14px;\n  padding: 14px;\n  box-shadow: 0 4px 14px rgba(0,0,0,0.06);\n}\n\n/* IMAGINI */\n.anunt-imagini {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n}\n\n.anunt-imagini img,\n.no-image {\n  width: 100px;\n  height: 80px;\n  flex-shrink: 0;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n/* HEADER */\n.anunt-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* GRID INFO */\n.anunt-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n\n/* DESCRIERE */\n.anunt-descriere p {\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n/* BUTOANE */\n.anunt-butoane {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.anunt-butoane button {\n  width: 100%;\n  justify-content: center;\n}\n\n/* DONATIE */\n.donatie-split {\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* ================= TABLET (>= 600px) ================= */\n\n@media (min-width: 600px) {\n\n  .anunt-card-complet {\n    flex-direction: row;\n    padding: 18px;\n  }\n\n  .anunt-imagini {\n    flex-direction: column;\n    min-width: 120px;\n  }\n\n  .anunt-imagini img,\n  .no-image {\n    width: 120px;\n    height: 100px;\n  }\n\n  .anunt-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .anunt-butoane {\n    flex-direction: row;\n  }\n\n  .anunt-butoane button {\n    width: auto;\n  }\n}\n\n/* ================= DESKTOP (>= 1024px) ================= */\n\n@media (min-width: 1024px) {\n\n  .lista-anunturi {\n    max-width: 1100px;\n    margin: 0 auto;\n  }\n\n  .anunt-card-complet {\n    gap: 24px;\n    padding: 22px;\n    border-radius: 18px;\n  }\n\n  .anunt-imagini img,\n  .no-image {\n    width: 140px;\n    height: 110px;\n  }\n\n  .anunt-descriere p {\n    font-size: 14px;\n  }\n}\n.card-promovat {\n  border: 2px solid #f4b400;\n  box-shadow: 0 4px 20px rgba(244, 180, 0, 0.15);\n}\n\n.promovat-ribbon {\n  background: linear-gradient(135deg, #f4b400, #f97316);\n  color: white;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  border-radius: 8px 8px 0 0;\n  height: 20px;\n}\n\n.btn-promoveaza {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: linear-gradient(135deg, #f4b400, #f97316);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n}\n.btn-promoveaza:hover { opacity: 0.9; }\n.btn-promoveaza.deja-promovat {\n  background: #fef3c7;\n  color: #92400e;\n  cursor: default;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
